<template>
  <div>
    <van-sticky>
      <van-search v-model="searchValue" placeholder="请输入委托编号、案名" left-icon='search' :show-action="userInfo.userType == 1" right-icon="" @search="getFilterValue">
        <div slot="action" @click="createNewSign">预约</div>
      </van-search>
      <FilterConfig v-model="filterInfo" :configs="filterList" @change="getFilterValue"></FilterConfig>
    </van-sticky>
    <section class="list_body">
      <van-list v-model="dataLoad.loading" :finished="dataLoad.finished" :error.sync="dataLoad.error" finished-text="没有更多了" error-text="请求失败，点击重新加载" @load="getList">
        <div class="mobile-nav" v-for="item in caseList" :key="item.ID" @click="checkDetail(item)">
          <div class="mobile-nav__item">
            <div class="van-cell van-cell--clickable">
              <div class="list_head">
                <span class="list_title">{{item.CaseName}}</span>
                <van-tag v-if="item.Status == '0'" color="#388CEB" plain>待处理</van-tag>
                <van-tag v-else-if="item.Status == '1'" color="#F5A623" plain>已分配</van-tag>
                <van-tag v-else-if="item.Status == '2'" color="#f56c6c" plain>已取消</van-tag>
                <van-tag v-else-if="item.Status == '3'" color="#7ED321" plain>已完成</van-tag>
                <van-button type="text" size="mini" @click.stop="checkOperation(item)">操作</van-button>
              </div>
              <van-row type="flex">
                <van-col span="12">
                  <span class="list_field">委托编号</span>
                  <span class="list_value">{{item.OrderNo}}</span>
                </van-col>
                <van-col span="12">
                  <span class="list_field">预约日期</span>
                  <span class="list_value">{{item.AppointmentDateTime}}</span>
                </van-col>
              </van-row>
              <van-row type="flex">
                <van-col span="12">
                  <span class="list_field">预约类型</span>
                  <span class="list_value">{{DoTypeStr(item.DoType)}}</span>
                </van-col>
                <van-col span="12">
                  <span class="list_field">签约法务</span>
                  <span class="list_value">{{item.SignLegalUser}}</span>
                </van-col>
              </van-row>
              <van-row type="flex">
                <van-col span="12">
                  <span class="list_field">预约区域</span>
                  <span class="list_value">{{item.AppointmentDistrict}}</span>
                </van-col>
                <van-col span="12">
                  <span class="list_field">办理人员</span>
                  <span class="list_value">{{item.DoUserName}}</span>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
      </van-list>
    </section>
    <van-action-sheet v-model="operationShow" :actions="operationList" @select="showOperation" />
    <van-action-sheet v-model="addSignShow" title="预约新增">
      <div>
        <van-field v-model="addSignOrderNo" clearable label="委托编号" placeholder="请输入委托编号" />
      </div>
      <div class="action-sheet-foot">
        <van-button type="text" size="mini" @click.stop="addSignShow=false">取消</van-button>
        <van-button type="text" size="mini" :disabled="!addSignOrderNo" @click.stop="addSign">预约</van-button>
      </div>
    </van-action-sheet>
    <van-row class="button_group" v-if="isWechat">
      <van-col :span="24">
        <van-button plain block square type="warning" @click="cancel">返回</van-button>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FilterConfig from '../../components/Head/filterConfig'
import * as boardApi from '../../api/board'
export default {
  data() {
    return {
      searchValue: '',
      filterConfigs: [
        {
          name: 'Status',
          title: '状态',
          value: '',
          option: [
            { text: '无', value: '' },
            { text: '待处理', value: '0' },
            { text: '已分配', value: '1' },
            { text: '已取消', value: '2' },
            { text: '已完成', value: '3' },
          ]
        }
      ],
      caseList: [],
      dataLoad: {
        loading: false,
        finished: true,
        error: false,
      },
      filterInfo: {},
      pageInfo: {
        currentPage: 1,
        total: 0,
        pageSizes: [5,10,20,30],
        pageSize: 8
      },
      operationShow: false,
      operationSelect: null,
      businessTypeList: [],//案件类型
      addSignShow: false,
      addSignOrderNo: ''
    }
  },
  filters: {
    
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      isWechat: state => state.isWechat
    }),
    /**获取用户筛选条件 */
    filterList(){
      let configs = this.userOperation;
      let ret = {
        commonOperation: [],
      };
      ret.commonOperation.push(...this.filterConfigs.filter(x => {
        return configs.commonOperation.some(t => x.name === t);
      }))
     
      return ret;
    },
    /**用户权限 */
    userOperation(){
      return {
        commonOperation: ['Status']
      };
    },
    //操作按钮
    operationList() {
      if(this.userInfo.userType == 0){
        return [
          { name: '修改', disabled: !this.buttonControl.update },
          { name: '处理', disabled: !this.buttonControl.deal },
          { name: '取消', disabled: !this.buttonControl.cancel },
        ]
      }else if(this.userInfo.userType == 1){
        return [
          { name: '修改', disabled: !this.buttonControl.update },
          { name: '取消', disabled: !this.buttonControl.cancel },
        ]
      }
    },
    //按钮可用性控制
    buttonControl(){
      let data = this.operationSelect;
      if(!data){
        return {
          update: false,
          deal: false,
          cancel: false
        }
      }
      return {
        detail: true,
        update: (()=>{
          return (this.userInfo.userType==1 && data.Status == "0" && data.ApplyUserID == this.userInfo.userNo) //经纪人编辑
          || (this.userInfo.userType==0 && data.Status == "1") //代书编辑法务
        })(),
        deal:(()=>{
          return data.Status == "0" || data.Status == "1";
        })(),
        cancel: (()=>{
          return (this.userInfo.userType==1 && data.Status == "0" && data.ApplyUserID == this.userInfo.userNo)
          || (this.userInfo.userType==0 && data.Status == "1") //代书编辑法务
        })()
      }
    }
  },
  components:{
    FilterConfig
  },
  methods: {
    cancel(){
      this.$router.go(-1);
    },
    getList(){
      this.filterInfo['search'] = this.searchValue;
      this.filterInfo['CityCode'] = this.userInfo.domain;
      boardApi.getBoardSignList(this.filterInfo,this.pageInfo.pageSize,this.pageInfo.currentPage).then((res)=>{
        if(res.IsSuccess){
          this.caseList = this.caseList.concat(res.Data.Data);
          this.pageInfo.currentPage++;
          if(res.Data.Data.length == 0){
            this.dataLoad.finished = true;
          }
        }else{
          this.dataLoad.finished = true;
          this.$notify({type:'danger',message:"获取列表失败"})
        }
        this.dataLoad.loading = false;
      })
    },
    createNewSign(){
      this.addSignShow = true;
    },
    //新增预约
    addSign(){
      boardApi.judgeCaseCanSign(this.addSignOrderNo).then(res=>{
        if(res.IsSuccess){
          this.$router.push('/board/add/'+this.addSignOrderNo);
        }else{
          this.$notify({ type: 'danger', message: res.Message });
        }
      })
    },
    /**获取查询条件 */
    getFilterValue(value){
      this.dataLoad.finished = false;
      this.dataLoad.loading = true;
      this.pageInfo.currentPage = 1;
      this.caseList = [];
      this.getList();
    },
    //选择操作
    checkOperation(item){
      this.operationShow = true;
      this.operationSelect = item;
    },
    /**选择操作栏 */
    showOperation(item){
      this.operationShow = false;
      switch(item.name)
      {
        case '修改': { 
          this.$router.push('/board/edit/'+this.operationSelect.ID);
        } break;
        case '处理': {
          this.$router.push('/board/deal/'+this.operationSelect.ID);
        } break;
        case '取消': {
          this.$dialog.confirm({
            title: '取消',
            message: '是否确认取消该预约'
          }).then(res => {
            boardApi.CancelAppointment(this.operationSelect.ID).then(res => {
              if(res && res.IsSuccess){
                this.$notify({ message: '预约取消成功', type: 'success' });
                this.getFilterValue();
              }else{
                this.$notify({ type: 'danger' , message: '预约取消失败!' });
                res ? console.log(res.Message) : null;
              }
            })
          }).catch(res => {})
        } break;
      }
    },
    //查看详情
    checkDetail(item){
      console.log(item);
      this.$router.push('/board/detail/' + item.ID);
    },
    //获取案件类型
    getBusinessTypeList(){
      boardApi.GetBusinessTypeList(this.userInfo.domain).then((res)=>{
         if(res.IsSuccess){
            this.businessTypeList=res.Data;
          }
      })
    },
    //案件类型描述
    DoTypeStr(value){
      if(value && this.businessTypeList.length > 0){
        return (this.businessTypeList.find(t => t.ItemCode == value) || {ItemName: ''}).ItemName;
      }
      return '';
    }
  },
  mounted(){
    this.getBusinessTypeList();
    this.$nextTick(()=>{
      this.getFilterValue();
    })
  }
}
</script>

<style scoped lang="less">
.list_body{
  box-sizing: border-box;
  width: 100%;
  padding: 20px 20px;
  background: #fff;

  .mobile-nav__item {
    margin-bottom: 16px;
    overflow: hidden;
    border-radius: 6px;
    box-shadow: 0 1px 5px #ebedf0;
  }
  .van-cell{
    font-size: 12px;
    display: block;

    .list_head{
      margin: 5px 0;

      .list_title{
        font-size: 16px;
        margin-right: 20px;
      }
      .van-button--text{
        float: right;
      }
    }
    

    .list_field{
      margin-right: 10px;
      color: #999999;
    }

    .list_value{
      color: #666666;
    }
  }
  .mobile-nav{
    position: relative;

    &.tag_zhixin::before{
      content: '执信';
      display: block;
      height: 2rem;
      width: 2rem;
      top: -1rem;
      left: -1rem;
      position: absolute;
      font-size: 0.9rem;
      background-color: #ff976a;
      border-radius: 1rem;
      color: #fff;
      z-index: 1;
      line-height: 2rem;
      text-align: center;
    }
    &.tag_lianmai::before{
      content: '联卖';
      display: block;
      height: 2rem;
      width: 2rem;
      top: -1rem;
      left: -1rem;
      position: absolute;
      font-size: 0.9rem;
      background-color: #28aa35;
      border-radius: 1rem;
      color: #fff;
      z-index: 1;
      line-height: 2rem;
      text-align: center;
    }
    &.tag_kewei::before{
      content: '科威';
      display: block;
      height: 2rem;
      width: 2rem;
      top: -1rem;
      left: -1rem;
      position: absolute;
      font-size: 0.9rem;
      background-color: #1989fa;
      border-radius: 1rem;
      color: #fff;
      z-index: 1;
      line-height: 2rem;
      text-align: center;
    }
    &.tag_qita::before{
      content: '其他';
      display: block;
      height: 2rem;
      width: 2rem;
      top: -1rem;
      left: -1rem;
      position: absolute;
      font-size: 0.9rem;
      background-color: #ff976a;
      border-radius: 1rem;
      color: #fff;
      z-index: 1;
      line-height: 2rem;
      text-align: center;
    }
  }
}

.action-sheet-foot{
  justify-content: flex-start;

  .van-button--text{
    font-size: 16px;
    float: left;
    margin: 10px;
  }
  .van-button--text + .van-button--text{
    float: right;
  }
}

.van-button--text{
  border: none;
  background-color: initial;
  color: #7ED321;

  &:active::before{
    opacity: 0;
  }
}

.van-button--text{
  border: none;
  background-color: initial;
  color: #7ED321;

  &:active::before{
    opacity: 0;
  }
}
.button_group{
  position: absolute;
  bottom: 0;
  width: 100%;
  position: fixed;
}
</style>
